// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1wOv8","title":"AfterBackImages_title__6gh21","images":"AfterBackImages_images__1mOV7"};